/** @format */

import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HmfBadgeComponent, HmfProductImageComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft,
	homefieldIconChevronRight,
	homefieldIconMediaPlay,
	homefieldIconPlMediaPlay
} from '@dsg-tech/homefield-angular-icons';

import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselSkeletonLoaderComponent } from './components/carousel-skeleton-loader/carousel-skeleton-loader.component';
import { CommonModule } from '@angular/common';
import { OptimizedImageComponentModule } from '@shared/media/components';
import { PinchToZoomModule } from './components/pinch-to-zoom/pinch-to-zoom.module';
import { ProductImageCarouselComponent } from './product-image-carousel.component';

@NgModule({
	declarations: [
		CarouselComponent,
		CarouselSkeletonLoaderComponent,
		ProductImageCarouselComponent
	],
	imports: [
		CommonModule,
		HmfBadgeComponent,
		HmfProductImageComponent,
		HomefieldIconLibraryModule,
		OptimizedImageComponentModule,
		PinchToZoomModule,
	],
	exports: [CarouselSkeletonLoaderComponent, ProductImageCarouselComponent]
})
export class ProductImageCarouselModule {
	constructor(
		private resolver: ComponentFactoryResolver,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronLeft,
			homefieldIconChevronRight,
			homefieldIconMediaPlay,
			homefieldIconPlMediaPlay
		]);
	}

	public resolveComponentFactory(): ComponentFactory<ProductImageCarouselModule> {
		return this.resolver.resolveComponentFactory(ProductImageCarouselModule);
	}
}
